// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  height: 100%;
}

#root {
  height: 100%;
}

body {
  font-family: "Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8f9fc;
}

.App {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Custom border colors for cards */
.border-left-primary {
  border-left: .25rem solid #4e73df !important;
}

.border-left-success {
  border-left: .25rem solid #1cc88a !important;
}

.border-left-info {
  border-left: .25rem solid #36b9cc !important;
}

.border-left-warning {
  border-left: .25rem solid #f6c23e !important;
}

.border-left-danger {
  border-left: .25rem solid #e74a3b !important;
}

/* Text colors */
.text-gray-800 {
  color: #5a5c69 !important;
}

.text-xs {
  font-size: .7rem;
}

/* Shadow */
.shadow {
  box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15) !important;
}

/* Card enhancements */
.card {
  border: 1px solid #e3e6f0;
  border-radius: .35rem;
}

.card-header {
  background-color: #f8f9fc;
  border-bottom: 1px solid #e3e6f0;
}

/* Table improvements */
.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, .05);
}

/* Button improvements */
.btn {
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  border-radius: .35rem;
}

.btn-primary {
  background: linear-gradient(180deg, #4e73df 10%, #224abe 100%);
  border-color: #4e73df;
}

.btn-success {
  background: linear-gradient(180deg, #1cc88a 10%, #13855c 100%);
  border-color: #1cc88a;
}

/* Progress bars */
.progress {
  border-radius: .35rem;
}

/* List group improvements */
.list-group-item-action:hover {
  background-color: #f8f9fc;
}

/* Chart container */
.chart-container {
  position: relative;
  height: 400px;
  width: 100%;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Loading spinner */
.spinner-border {
  width: 3rem;
  height: 3rem;
}

/* Sidebar button styling */
.sidebar .btn-outline-light {
  color: #fff !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  font-weight: 500;
  transition: all 0.3s ease;
}

.sidebar .btn-outline-light:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  color: #fff !important;
}

.sidebar .btn-info,
.sidebar .btn-success,
.sidebar .btn-warning,
.sidebar .btn-danger,
.sidebar .btn-primary,
.sidebar .btn-secondary {
  color: #fff !important;
  font-weight: 600;
}

.sidebar .btn-warning {
  color: #000 !important;
  font-weight: 600;
}

/* Sidebar scrollbar */
.sidebar::-webkit-scrollbar {
  width: 8px;
}

.sidebar::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Guide Me pulse animation */
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 0 20px 10px rgba(40, 167, 69, 0.2);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}

/* Guide Me highlight animation */
@keyframes guideHighlight {
  0% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);
  }
  50% {
    box-shadow: 0 0 20px 5px rgba(102, 126, 234, 0.3);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,+DAA+D;AACjE;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;EAC9D,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;EAC9D,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,iDAAiD;EACjD,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,sBAAsB;IACtB,gDAAgD;EAClD;EACA;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,iDAAiD;EACnD;EACA;IACE,4CAA4C;EAC9C;AACF","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  height: 100%;\n}\n\n#root {\n  height: 100%;\n}\n\nbody {\n  font-family: \"Nunito\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f8f9fc;\n}\n\n.App {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Custom border colors for cards */\n.border-left-primary {\n  border-left: .25rem solid #4e73df !important;\n}\n\n.border-left-success {\n  border-left: .25rem solid #1cc88a !important;\n}\n\n.border-left-info {\n  border-left: .25rem solid #36b9cc !important;\n}\n\n.border-left-warning {\n  border-left: .25rem solid #f6c23e !important;\n}\n\n.border-left-danger {\n  border-left: .25rem solid #e74a3b !important;\n}\n\n/* Text colors */\n.text-gray-800 {\n  color: #5a5c69 !important;\n}\n\n.text-xs {\n  font-size: .7rem;\n}\n\n/* Shadow */\n.shadow {\n  box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15) !important;\n}\n\n/* Card enhancements */\n.card {\n  border: 1px solid #e3e6f0;\n  border-radius: .35rem;\n}\n\n.card-header {\n  background-color: #f8f9fc;\n  border-bottom: 1px solid #e3e6f0;\n}\n\n/* Table improvements */\n.table-hover tbody tr:hover {\n  background-color: rgba(0, 0, 0, .05);\n}\n\n/* Button improvements */\n.btn {\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  border-radius: .35rem;\n}\n\n.btn-primary {\n  background: linear-gradient(180deg, #4e73df 10%, #224abe 100%);\n  border-color: #4e73df;\n}\n\n.btn-success {\n  background: linear-gradient(180deg, #1cc88a 10%, #13855c 100%);\n  border-color: #1cc88a;\n}\n\n/* Progress bars */\n.progress {\n  border-radius: .35rem;\n}\n\n/* List group improvements */\n.list-group-item-action:hover {\n  background-color: #f8f9fc;\n}\n\n/* Chart container */\n.chart-container {\n  position: relative;\n  height: 400px;\n  width: 100%;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Loading spinner */\n.spinner-border {\n  width: 3rem;\n  height: 3rem;\n}\n\n/* Sidebar button styling */\n.sidebar .btn-outline-light {\n  color: #fff !important;\n  border-color: rgba(255, 255, 255, 0.3) !important;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.sidebar .btn-outline-light:hover {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.5) !important;\n  color: #fff !important;\n}\n\n.sidebar .btn-info,\n.sidebar .btn-success,\n.sidebar .btn-warning,\n.sidebar .btn-danger,\n.sidebar .btn-primary,\n.sidebar .btn-secondary {\n  color: #fff !important;\n  font-weight: 600;\n}\n\n.sidebar .btn-warning {\n  color: #000 !important;\n  font-weight: 600;\n}\n\n/* Sidebar scrollbar */\n.sidebar::-webkit-scrollbar {\n  width: 8px;\n}\n\n.sidebar::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n}\n\n.sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n/* Guide Me pulse animation */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);\n  }\n  50% {\n    transform: scale(1.02);\n    box-shadow: 0 0 20px 10px rgba(40, 167, 69, 0.2);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n  }\n}\n\n/* Guide Me highlight animation */\n@keyframes guideHighlight {\n  0% {\n    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 20px 5px rgba(102, 126, 234, 0.3);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
